<template>
  <editor
    id="uuid"
    apiKey="93cjcldzxraxa16fstfwf25kqk8egbm6bsq9u8lzi3c5fvos"
    :init="{
      plugins: 'advlist anchor autolink charmap code fullscreen help image insertdatetime link lists media preview searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | styles | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
      height: 500,
    }"
    v-model="localValue"
  />
</template>

<script>
import { ref, watch } from 'vue';
import Editor from '@tinymce/tinymce-vue'

export default {
  components: { Editor },
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const localValue = ref(props.modelValue)

    watch(
      () => props.modelValue,
      (v) => {
        if (v !== localValue.value) localValue.value = v
      }
    )

    watch(
      localValue,
      (v) => {
        emit('update:modelValue', v)
      }
    )

    return { localValue };
  }
};
</script>
